import { render, staticRenderFns } from "./Testout.vue?vue&type=template&id=257228c3&scoped=true&lang=pug"
import script from "./Testout.vue?vue&type=script&lang=ts"
export * from "./Testout.vue?vue&type=script&lang=ts"
import style0 from "./Testout.vue?vue&type=style&index=0&id=257228c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257228c3",
  null
  
)

export default component.exports